import { render, staticRenderFns } from "./Home.domains.vue?vue&type=template&id=242aadf6&scoped=true&"
import script from "./Home.domains.vue?vue&type=script&lang=js&"
export * from "./Home.domains.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242aadf6",
  null
  
)

export default component.exports